import React, { FC, useRef, useMemo, useEffect } from "react";
import CardEntitlement from "../CardEntitlement";
import RichText from "../richtext";
import "./Card.css";
import CardContext from "../../utils/store/card-context";
import { getElementMaximumHeight } from "../../utils/utils";
import ProductDetails from "../ProductDetailsComp/ProductDetails";
import StaticPriceComp from "../StaticPriceComp/StaticPriceComp";
import { ComponentMetadata } from "../types";
import DynamicPrice from "../DynamicPriceComp/DynamicPrice";

interface CardSchema {
  content: any;
  updatedContent: any;
  indexKey: number;
  listLength: number;
  addToCart?: (e: any) => void;
  metadata?: ComponentMetadata | undefined;
  modalTriggered?: () => void;
  showPrice?: any;
}

const Card: FC<CardSchema> = ({
  content,
  updatedContent,
  indexKey,
  listLength,
  addToCart,
  metadata,
  modalTriggered,
  showPrice
}): any => {
  const story: any = {
    ...(content?.testProductReference?.[0]?.reference ?? content?.reference),
  };
  const obj = {
    listLength,
    indexKey,
    arrowUpIcon: story?.content?.body?.[0]?.arrowUp?.filename,
    arrowDownIcon: story?.content?.body?.[0]?.arrowDown?.filename,
    arrowLeftRed: story?.content?.body?.[0]?.arrowLeftRed?.filename,
  };
  const showEntitleValue = updatedContent?.enableNewAddToCart ?? false;
  const titleEle = useRef<HTMLDivElement>(null);
  const toolTipEle = useRef<HTMLDivElement>(null);
  const callbacks = useMemo(() => obj, [obj]);
  const findHeight = () => {
    getElementMaximumHeight("linetable-card-title", listLength);
    getElementMaximumHeight("linetable-card-tooltiptxt", listLength);
    getElementMaximumHeight("linetable-card-bottomConatiner", listLength);
  };
  useEffect(() => {
    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener("resize", findHeight);
  }, [content]);
  return (
    <CardContext.Provider value={callbacks}>
      <div className={"linetable-card-productTeaser"}>
        <div className={"linetable-card-productContainer "}>
          {story.content && (
            <>
              <div
                className={"linetable-card-titleContainer"}
                id={`linetable-card-title${indexKey}`}
                ref={titleEle}
              >
                <div className={"linetable-card-prodHeading"}>
                  {story?.content?.body[0]?.name}
                </div>
                <div className={"linetable-card-productTitle"}>
                  <h3>{story?.content?.body[0]?.displayName}</h3>
                  {story?.content?.body[0]?.prodImage?.filename && (
                    <img
                      src={story?.content?.body[0]?.prodImage?.filename}
                      height={15}
                      width={20}
                      alt='card'
                    />
                  )}
                </div>
                <div className={"linetable-card-prodDescription"}>
                  <RichText content={story?.content?.body[0]?.description} />
                </div>
              </div>
              {!updatedContent?.isPrepaidFlow && <hr />}
            </>
          )}
          {story?.content && story?.content?.body[0]?.introText && (
            <>
              <div
                className={`${
                  showEntitleValue ? "d-block" : "d-none d-sm-block"
                }`}
              >
                <div
                  className={"linetable-card-introText"}
                  id={`linetable-card-tooltiptxt${indexKey}`}
                  ref={toolTipEle}
                >
                  <RichText content={story?.content?.body[0]?.introText} />
                </div>
                <hr />
              </div>
            </>
          )}
          {(story?.content?.body[0]?.entitlementConfig || [])?.map(
            (item: any, index: number) => (
              <CardEntitlement
                content={item}
                product={content}
                key={index}
                indexKey={index}
                showEntitleValue={showEntitleValue}
                metadata={metadata}
                modalTriggered={modalTriggered}
              />
            )
          )}
          <hr />
          <div id={`linetable-card-bottomConatiner${indexKey}`} className="linetable-card-bottomConatiner">
            <div className="linetable-card-productDetailSection">
              {story?.content?.body?.[0]?.productDetailIcon?.filename && (
                <img
                  src={story?.content?.body?.[0]?.productDetailIcon?.filename}
                  width={24}
                  height={24}
                  alt='productDetailIcon'
                />
              )}
              <ProductDetails
                content={story?.content?.body?.[0]}
                updatedContent={updatedContent}
                modalTriggered={modalTriggered}
                addToCart={addToCart}
              />
            </div>
            <div>
              {story?.content?.body?.[0]?.isEnablePrice && (
                <StaticPriceComp
                  content={story?.content?.body?.[0]}
                  addToCart={addToCart}
                  variant="productCard"
                />
              )}
            </div>
            <div>
              {!story?.content?.body?.[0]?.isEnablePrice &&
                !updatedContent?.staticPrice && (
                  <DynamicPrice
                    content={story?.content?.body?.[0]}
                    showPrice={showPrice}
                    addToCart={addToCart}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </CardContext.Provider>
  );
};
export default Card;
